import React, { useRef, useEffect, useState } from "react";
import { DatePicker as RainbowDatePicker, Application } from "react-rainbow-components";
import "./style.css";

const containerStyles = {
  maxWidth: 400,
  display: "none",
};

type Props = {
  value: Date | null;
  setValue: (value: Date) => void;
  label?: string;
  formatStyle?: "large" | "medium" | "small";
  isDisabled?: boolean;
  dateFormatOptions?: Intl.DateTimeFormatOptions; // New prop for date format options
  error?: {
    valid: boolean;
    message: string;
  };
  hideValidation?: boolean;
};

const theme = {
  rainbow: {
    palette: {
      brand: "#FEC307",
    },
  },
};

const DatePicker: React.FC<Props> = ({ value, setValue, label = "Date", formatStyle = "large", isDisabled, error, dateFormatOptions, hideValidation }) => {
  const datePickerRef = useRef(null);

  const testResult = !error ? "valid" : error.valid ? "valid" : "invalid";
  const inputClass = `is-${testResult}`;
  const labelClass = `${testResult}-feedback`;

  const openModal = () => {
    if (datePickerRef.current && !isDisabled) {
      const datePicker = datePickerRef.current;
      if (datePicker) {
        datePicker.click();
      }
    }
  };

  const [formattedValue, setFormattedValue] = useState("");

  const formatDateTime = (date: Date) => {
    const defaultOptions = {
      weekday: "short" as const,
      month: "short" as const,
      day: "numeric" as const,
      year: "numeric" as const,
    };

    const formatOptions = dateFormatOptions ? dateFormatOptions : defaultOptions;

    return new Intl.DateTimeFormat("en-US", formatOptions).format(date);
  };

  useEffect(() => {
    if (value) {
      const formattedDate = formatDateTime(value);
      setFormattedValue(formattedDate);
    } else {
      setFormattedValue("");
    }
  }, [value]);

  return (
    <Application theme={theme}>
      <div className="date-picker-container">
        <div className="form-floating">
          <input
            type="text"
            name={"date-picker"}
            id={"date-picker"}
            className={`form-control ${hideValidation ? "" : inputClass}`}
            placeholder="Date"
            value={formattedValue}
            readOnly
            onClick={openModal}
            disabled={isDisabled}
          />

          <label htmlFor="date-picker" className={`floating`}>
            {label}
          </label>
          {error && !error?.valid && <span className={labelClass}>{error?.message}</span>}
        </div>
        <div className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto date date-picker-container" style={containerStyles}>
          <RainbowDatePicker className="date-picker-container" ref={datePickerRef} label={label} value={value} onChange={setValue} formatStyle={formatStyle} borderRadius="semi-square" />
        </div>
      </div>
    </Application>
  );
};

export default DatePicker;
